export default __webpack_public_path__ + "static/media/BG-Green-0001.2a272491.png";